module.exports = __webpack_public_path__ + "static/media/store-blue.0728763e.svg";